export default __webpack_public_path__ + "static/media/statistics.0eab2e2e.png";